export const SOLDIERS = 0,
  SERGANTS = 1,
  OFFICERS = 2;

export const WORK_EMPLOYMENT_TYPE = [
  {
    id: SOLDIERS,
    name: 'Солдатські'
  },
  {
    id: SERGANTS,
    name: 'Сержантські/Старшинські'
  },
  {
    id: OFFICERS,
    name: 'Офіцерські'
  }
];

export const LOBBY_X = 0,
  JOOBLE = 1,
  WORK_UA = 2,
  TRO = 3,
  AF = 4,
  DSV = 5,
  NGU = 6;

export const WORK_VENDORS = [
  {
    id: LOBBY_X,
    name: 'army.thelobbyx.com'
  },
  {
    id: JOOBLE,
    name: 'ua.jooble.org'
  },
  {
    id: WORK_UA,
    name: 'work.ua'
  },
  {
    id: TRO,
    name: 'Сили Територіальної Оборони Збройних Сил України'
  },
  {
    id: AF,
    name: 'Повітряні сили'
  },
  {
    id: DSV,
    name: 'Десантно-штурмові війська Збройних сил України'
  },
  {
    id: NGU,
    name: 'Національна гвардія України'
  }
];
